import React, {Component} from 'react';
import I18n from 'lib/i18n/i18n';
import {imageUrl} from 'helpers/ApplicationHelper';
import ReactEcharts from 'echarts-for-react'; 
import getOption from './chartOptions/subset';


class SubsetItem extends Component {

    render() {
        let subsetName = this.props.subsetName;
        if(!subsetName) return <noscript></noscript>;

        let image_path = `item/trends/${subsetName}.svg`;
        let brand_images = this.props.brand_images;

        if(subsetName === 'brand'){
            if(!brand_images[this.props.brand]){
                return (<div style={{display: 'none'}}></div>)
            }
            image_path = `brands/desktop/${brand_images[this.props.brand]}-black.png`;
        }

        const {lastItem} = this.props
        return (
            <div>
                <div className={`subset ${subsetName}`}>
                    <div className="subset-icon">
                        <div className="icon-wrapper">
                            <img className={subsetName} src={imageUrl(image_path)} />
                            <br/>
                            <div className="text">{I18n.getString(`itemPage::trends::subsets::${subsetName}`)}</div>
                        </div>
                    </div>
                    <div className="subset-chart">
                        <ReactEcharts option={getOption(this.props)} style={{ height: '100%', width: '100%' }}/>
                    </div>
                </div>
                {!lastItem && <div className="plus">+</div>}
            </div>
        )
    }
}

export default  SubsetItem;